/** Pick the best representative logo for a department from its payments */
export function getDeptLogo(dept) {
  if (dept.deptLogo) return dept.deptLogo;
  const withLogo = dept.payments.find((p) => p.logo);
  return withLogo?.logo || null;
}

export function portalHost(url) {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return "";
  }
}

const DIRECT_PAY_RE = /wologin|sbicollect|payment\.gst|pay\.ecourts|echallan|cus-login|online-payment|property-tax-online-payment|madrasuniv|idms-login|fastag|awp\/login|challan\/echallan|tnurbanepay|propertytax|tnebnet|onlineppa|login\.aspx/i;

export function isDirectPaymentUrl(url) {
  return typeof url === "string" && DIRECT_PAY_RE.test(url);
}

/** Official pay/login screen — not the corporation homepage */
export function paymentDirectUrl(payment) {
  if (payment.payUrl) return payment.payUrl;
  if (isDirectPaymentUrl(payment.url)) return payment.url;
  return payment.url;
}

/** Department / corporation homepage */
export function paymentPortalUrl(payment) {
  if (payment.portalUrl) return payment.portalUrl;
  try {
    const u = new URL(payment.payUrl || payment.url);
    return `${u.origin}/`;
  } catch {
    return payment.url;
  }
}
